import React from 'react';
import { ClipboardList, Clock, Quote } from 'lucide-react';

const CHECKLIST_LABELS = {
  service_standard: 'Service standard', grand_service: 'Grand service', changement_roues: 'Changement de roues', montage_pneus: 'Montage pneus',
  controle_expertise: 'Contrôle avant expertise', preparation_expertise: 'Préparation expertise', presentation_expertise: 'Présentation expertise',
  diagnostic: 'Diagnostic', reparation: 'Réparation', peinture: 'Peinture', cas_assurance: 'Cas assurance',
};

export const TodoBlock = ({ wo }) => {
  const r = wo.request || {};
  const motifs = r.motif_labels || [];
  const checks = Object.entries(wo.checklist || {}).filter(([, v]) => v).map(([k]) => CHECKLIST_LABELS[k] || k);
  const ops = (wo.operations || []).filter(o => o.status !== 'cancelled');
  const words = r.client_request || '';
  const desc = wo.description && wo.description !== words ? wo.description : '';
  const empty = !motifs.length && !(r.precisions || []).length && !checks.length && !ops.length && !words && !desc;
  return (
    <div className="rounded-2xl border-4 border-[#FACC15] bg-[#0E1116] text-white p-5 space-y-3" data-testid="atelier-todo-block">
      <div className="flex items-center gap-2 flex-wrap">
        <ClipboardList className="w-6 h-6 text-[#FACC15]" />
        <h2 className="text-lg font-black uppercase tracking-wide text-[#FACC15]">Travaux à effectuer</h2>
        <span className="text-xs text-slate-400">demandés par la réception</span>
        {wo.allocated_hours > 0 && <span className="ml-auto px-3 py-1 rounded-full bg-[#FACC15] text-[#0E1116] text-sm font-bold flex items-center gap-1" data-testid="todo-allocated"><Clock className="w-4 h-4" />{wo.allocated_hours} h prévues</span>}
      </div>
      {motifs.length > 0 && <div className="flex flex-wrap gap-2">{motifs.map(m => <span key={m} className="px-3 py-1.5 rounded-lg bg-[#FACC15] text-[#0E1116] font-black text-base" data-testid="todo-motif">{m}</span>)}</div>}
      {(r.precisions || []).length > 0 && <div className="flex flex-wrap gap-1.5">{r.precisions.map(p => <span key={p} className="px-2.5 py-1 rounded-full border border-[#FACC15]/60 text-sm">{p}</span>)}</div>}
      {words && <p className="text-base flex gap-2 bg-white/10 rounded-lg p-3" data-testid="todo-client-words"><Quote className="w-5 h-5 text-[#FACC15] shrink-0" />{words}</p>}
      {(ops.length > 0 || checks.length > 0) && (
        <ul className="space-y-1.5" data-testid="todo-list">
          {[...ops.map(o => [o.id, o.name, o.status === 'done']), ...checks.map(c => [c, c, false])].map(([k, label, done]) => (
            <li key={k} className={`flex items-center gap-2 text-base font-semibold ${done ? 'line-through text-slate-500' : ''}`}>
              <span className={`w-5 h-5 rounded border-2 shrink-0 ${done ? 'bg-emerald-500 border-emerald-500' : 'border-[#FACC15]'}`} />{label}
            </li>))}
        </ul>
      )}
      {desc && <p className="text-sm whitespace-pre-wrap text-slate-200" data-testid="todo-description">{desc}</p>}
      {empty && <p className="text-sm text-slate-400">Aucune consigne saisie par la réception.</p>}
    </div>
  );
};
